import { useEffect, useRef } from "react";

/** Cached balances render first. Each authenticated wallet session then reads
 * authoritative state, including an account/key change while still connected. */
export function useWalletBackgroundRefresh(
  scope: object,
  ready: boolean,
  refresh: () => Promise<unknown>,
) {
  const latest = useRef(refresh);
  latest.current = refresh;
  useEffect(() => {
    if (ready)
      void latest.current().catch(() => {
        /* Refresh owns its status. */
      });
  }, [scope, ready]);
}
